var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application"},[_c('h1',[_vm._v("爱股票合作者服务规范")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content.replace(/\n/gi, '<br />'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }